<template>
	<b-container fluid>
		<bo-page-title />
		<section id="contact">
			<b-card v-if="isList" no-body>
				<template #header>
					<div class="d-flex align-items-center">
						<h5 class="card-title">Mitra</h5>
					</div>
				</template>
				<b-card-body>
					<b-row>
						<b-col md>
						</b-col>
						<b-col md="auto">
							<div class="d-flex">
									<b-form @submit.prevent="doFilter()" class="d-flex">
									<b-input-group>
									<b-form-input v-model="filter.search" v-on:keyup.13="$emit('search')" placeholder="Type keyword then enter..."></b-form-input>
									<b-input-group-append>
										<b-button @click="doFilter()" variant="success"><i class="fas fa-search"></i></b-button>
									</b-input-group-append>
									</b-input-group>
									<b-button
										class="ml-1 d-inline-flex align-items-center"
										variant="outline-success"
										@click="doReset()"
									>Reset</b-button>
								</b-form>
							</div>
						</b-col>
					</b-row>
				</b-card-body>
				<b-table :fields="orderFields" :items="dataList||[]" show-empty :busy="!dataList">
					<template #cell(num)="data">{{ data.index += 1 }}</template>
					<template #table-busy>
            <div class="text-center text-danger my-2">
              <b-spinner class="align-middle"></b-spinner>
              <strong>Loading...</strong>
            </div>
          </template>
					<template #cell(company_name)="data">
						<div>{{ data.item.ap_company_name }}</div>
					</template>
					<template #cell(company_address)="data">
						<div>{{ data.item.ap_company_address }}</div>
					</template>
					<template #cell(pic_information)="data">
						<span class="d-inline-block">
							<i class="ti-user mr-1"></i>
							<span>{{ data.item.ap_pic_name }}</span>
						</span><br/>
						<span class="d-inline-block">
							<i class="icon-phone mr-1"></i>
							<span>{{ data.item.ap_pic_phone }}</span>
						</span>
					</template>
					<template #cell(date)="data">
						<div>{{ data.item.ap_created_date | moment('LLL') }}</div>
					</template>
					<template #cell(actions)="data">
						<b-button v-if="moduleRole('detail')" variant="outline-info" class="btn-icon" v-b-tooltip.hover="'Detail'" @click="detailPartnership(data.item)"><i class="icon-eye"></i></b-button>
					</template>
					<template #empty>
						<div class="text-center">
							<b-img class="mb-2" width="90" fluid src="/assets/images/no-data.png" />
							<h4 align="center"><span v-if="Object.keys(filter).length">no data shown</span><span v-else>No {{ pageTitle }} listed yet</span></h4>
						</div>
					</template>
				</b-table>
				<template #footer>
					<b-pagination v-if="data.total > data.per_page" class="mb-0 justify-content-end" v-model="pageNo"
						:per-page="data.per_page" :total-rows="data.total" />
				</template>
			</b-card>
			<b-modal
				id="partnershipDetail"
				title="Mitra Detail"
				centered
				no-close-on-backdrop
				size="lg"
			>
				<b-row class="gx-0 gy-2">
					<b-col md="6">
						<div class="ip-details px-0">
							<div class="ipd-item">
								<strong>Company Name</strong>
								<span>{{row.ap_company_name}}</span>
							</div>
						</div>
					</b-col>
					<b-col md="6">
						<div class="ip-details px-0">
							<div class="ipd-item">
								<strong>Company Address</strong>
								<span>{{row.ap_company_address}}</span>
							</div>
						</div>
					</b-col>
					<b-col md="6">
						<div class="ip-details px-0">
							<div class="ipd-item">
								<strong>Bussiness Line</strong>
								<span>{{row.ap_bussiness_line}}</span>
							</div>
						</div>
					</b-col>
					<b-col md="6">
						<div class="ip-details px-0">
							<div class="ipd-item">
								<strong>Company Phone</strong>
								<span>{{row.ap_company_name}}</span>
							</div>
						</div>
					</b-col>
					<b-col md="6">
						<div class="ip-details px-0">
							<div class="ipd-item">
								<strong>Company Website</strong>
								<a :href="row.ap_company_url">{{row.ap_company_url}}</a>
							</div>
						</div>
					</b-col>
					<b-col md="6">
						<div class="ip-details px-0">
							<div class="ipd-item">
								<strong>PIC Name</strong>
								<span>{{row.ap_pic_name || '-'}}</span>
							</div>
						</div>
					</b-col>
					<b-col md="6">
						<div class="ip-details px-0">
							<div class="ipd-item">
								<strong>Contact PIC</strong>
								<span>{{row.ap_pic_phone}}</span>
							</div>
						</div>
					</b-col>
					<b-col md="4">
						<div class="ip-details px-0">
							<div class="ipd-item">
								<strong>Akta Pendirian</strong>
								<a :href="uploader(row.ap_doc_akta_pendirian)" target="_blank" class="btn btn-uploader" v-if="row.ap_doc_akta_pendirian">
									<i class="ti-file"></i>
									<span class="align-middle ml-3">View File</span>
								</a>

								<span v-else>-</span>
							</div>
						</div>  
					</b-col>
					<b-col md="4">
						<div class="ip-details px-0">
							<div class="ipd-item">
								<strong>Company Profile</strong>
								<a :href="uploader(row.ap_doc_company_profile)" target="_blank" class="btn btn-uploader" v-if="row.ap_doc_company_profile">
									<i class="ti-file"></i>
									<span class="align-middle ml-3">View File</span>
								</a>

								<span v-else>-</span>
							</div>
						</div>  
					</b-col>
					<b-col md="4">
						<div class="ip-details px-0">
							<div class="ipd-item">
								<strong>Main Director Document</strong>
								<a :href="uploader(row.ap_doc_main_director)" target="_blank" class="btn btn-uploader" v-if="row.ap_doc_main_director">
									<i class="ti-file"></i>
									<span class="align-middle ml-3">View File</span>
								</a>

								<span v-else>-</span>
							</div>
						</div>  
					</b-col>
					<b-col md="6">
						<div class="ip-details px-0">
							<div class="ipd-item">
								<strong>NIB</strong>
								<p class="mb-0">{{ row.ap_nib||'-' }}</p>
								<a :href="uploader(row.ap_doc_nib)" target="_blank" class="btn btn-uploader" v-if="row.ap_doc_nib">
									<i class="ti-file"></i>
									<span class="align-middle ml-3">View File</span>
								</a>

								<span v-else>-</span>
							</div>
						</div>  
					</b-col>
					<b-col md="6">
						<div class="ip-details px-0">
							<div class="ipd-item">
								<strong>NPWP</strong>
								<p class="mb-0">{{ row.ap_npwp||'-' }}</p>
								<a :href="uploader(row.ap_doc_npwp)" target="_blank" class="btn btn-uploader" v-if="row.ap_doc_npwp">
									<i class="ti-file"></i>
									<span class="align-middle ml-3">View File</span>
								</a>

								<span v-else>-</span>
							</div>
						</div>  
					</b-col>
					<b-col md=12 v-if="row.ap_created_date">
						<div class="ip-details px-0">
							<div class="ipd-item">
								<strong>Date</strong>
								<p v-if="row.ap_created_date">Created at: {{ row.ap_created_date | moment('LLLL') }}</p>
							</div>
						</div>
					</b-col>
				</b-row>
				<template #modal-footer>
					<b-button variant="primary" @click.prevent="closeModalDetail">Close</b-button>
				</template>
			</b-modal>
		</section>
	</b-container>
</template>

<script>
	import GlobalVue from '@/libs/Global.vue'
	const _ = global._


	export default {
		name: 'BoContact',
		extends: GlobalVue,
		computed: {
			filterByStatus() {
				return this.$route.query.filterByStatus || "all"
			}
		},
		mounted() {
			this.$root.$on('bv::modal::hidden', () => {
				this.apiGet()
			})
			this.apiGet()
		},
		data() {
			return {
				countData: {},
				seoRow: {},
				heroEditorOpen: false,
				orderFields: [
					{
						key: 'num',
						label: '#'
					}, 
					{
						key: 'company_name',
						label: 'Company Name'
					}, 
					{
						key: 'company_address',
						label: 'Company Address'
					}, 
					{
						key: 'pic_information',
						label: 'PIC'
					}, 
					{
						key: 'date',
						label: 'Date'
					}, 
				'actions', ],
				filter: {},
			}
		},
		methods: {
			detailPartnership(item){
				this.row = _.clone(item)
				this.$bvModal.show('partnershipDetail')
			},
			closeModalDetail(){
				this.row = {}
				this.$bvModal.hide('partnershipDetail')
			}
		},
		watch: {
			$route() {
				this.apiGet()
			},
			'$route.params.pageSlug': function () {
				this.$set(this, 'filter', {})
			},
		}
	}
</script>

<style scoped>

.btn-uploader {
	text-transform: unset;
	font-size: 16px;
	font-weight: 500;
	padding-top: 0.5rem;
	padding-bottom: 0.5rem;
	background-color: #eee;
	border: 2px dashed #777;
	width: 150px;
	
}

</style>